module.exports = __webpack_public_path__ + "img/about-title.ff5a5ee6.png";